.region {
  bottom: var(--pgm-sys-spacing-6);
  display: flex;
  justify-content: center;
  left: var(--pgm-sys-spacing-4);
  pointer-events: none;
  position: fixed;
  right: var(--pgm-sys-spacing-4);
  z-index: 1200;
}

.snackbar {
  align-items: center;
  animation: enter 0.15s ease-out;
  background-color: var(--pgm-sys-color-inverse-surface);
  border-radius: 4px;
  box-shadow: var(--pgm-sys-elevation-level3);
  box-sizing: border-box;
  display: flex;
  max-width: 560px;
  min-height: 48px;
  padding: var(--pgm-sys-spacing-3) var(--pgm-sys-spacing-4);
  pointer-events: auto;
}

.message {
  color: var(--pgm-sys-color-inverse-on-surface);
}

@keyframes enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
}
